import { addNotify } from 'features/Notify/redux/actions';

const actionTypes = {
  GET_MY_BETS: 'history/GET_MY_BETS',
  GET_TOP_WINS_SUCCESS: 'history/GET_TOP_WINS_SUCCESS',
  SET_IS_PROCESS: 'history/SET_IS_PROCESS',
  UPDATE_BET: 'history/UPDATE_BET',
}

const getMyBets = () => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.SET_IS_PROCESS, payload: true })
  const { api } = extra;
  const { locale } = getState();
  const { token } = getState().auth;
  const response = await api.history.getMyBets(30, token);
  if (response.success) {
    dispatch({ type: actionTypes.GET_MY_BETS, payload: response.data });
  } else {
    dispatch(addNotify(locale.error, 'error'));
  }
  dispatch({ type: actionTypes.SET_IS_PROCESS, payload: false });
}

const getTopWins = () => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.SET_IS_PROCESS, payload: true })
  const { api } = extra;
  const { locale } = getState();
  const response = await api.history.getTopWins();
  if (response.success) {
    dispatch({ type: actionTypes.GET_TOP_WINS_SUCCESS, payload: response.data });
  } else {
    dispatch(addNotify(locale.error, 'error'));
  }
  dispatch({ type: actionTypes.SET_IS_PROCESS, payload: false });
}

const updateBet = data => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.UPDATE_BET, payload: data })
}

export {
  actionTypes,
  getMyBets,
  getTopWins,
  updateBet,
}